package com.anjuros.website.redesign.sections.about

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdClosingCard
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

@Composable
fun AboutClosingSection() {
    RdClosingCard(
        RdText.ABOUT_CLOSE_EYEBROW, RdText.ABOUT_CLOSE_TITLE, RdText.ABOUT_CLOSE_LEDE,
        secondaryText = if (SHOW_CLIENT_WORK) RdText.ABOUT_CLOSE_WORK else RdText.ABOUT_CLOSE_DESIGNS,
        secondaryPath = if (SHOW_CLIENT_WORK) "#$ABOUT_WORK_ID" else RdRoute.DESIGNS,
    )
}
